import { makeVar } from '@apollo/client';

export type RootRouteMode = 'manager' | 'scheduler' | 'report' | 'funnel' | 'super';

const ROOT_ROUTE_MODES: RootRouteMode[] = ['manager', 'scheduler', 'report', 'funnel', 'super'];

const ROOT_ROUTE_MODE_STORAGE_KEY = 'overwatch:rootRouteMode';

const DEFAULT_ROOT_ROUTE_MODE: RootRouteMode = 'manager';

const isRootRouteMode = (value: unknown): value is RootRouteMode =>
  typeof value === 'string' && (ROOT_ROUTE_MODES as string[]).includes(value);

const getStoredRootRouteMode = (): RootRouteMode => {
  const stored = localStorage.getItem(ROOT_ROUTE_MODE_STORAGE_KEY);
  return isRootRouteMode(stored) ? stored : DEFAULT_ROOT_ROUTE_MODE;
};

export const rootRouteModeVar = makeVar<RootRouteMode>(getStoredRootRouteMode());

export const setRootRouteMode = (mode: RootRouteMode): void => {
  localStorage.setItem(ROOT_ROUTE_MODE_STORAGE_KEY, mode);
  rootRouteModeVar(mode);
};
